// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge.badge-pill[data-v-3b2a70e2]{height:2rem;display:inline-flex;align-items:center}.category-item[data-v-3b2a70e2]{border-bottom:4px solid #c7d121}", ""]);
// Exports
module.exports = exports;
